import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/map_labeling",
  name: "map_labeling",
  component: function component() {
    return import("../../../views/member/map_labeling/index.vue");
  },
  meta: {
    foot: true
  }
}, {
  path: "/map_labeling_store",
  name: "map_labeling_store",
  component: function component() {
    return import("../../../views/member/map_labeling/store_location.vue");
  },
  meta: {
    foot: true
  }
}, {
  path: "/map_labeling_record",
  name: "map_labeling_record",
  component: function component() {
    return import("../../../views/member/map_labeling/record.vue");
  },
  meta: {
    foot: true
  }
}];